import React from 'react';
import {
    RichCell,
    Button,
    SplitLayout,
    SplitCol,
    Div,
    PanelHeader,
    PanelHeaderButton,
    Search,
    Cell,
    List,
    Spinner,
    Pagination,
    ButtonGroup, Chip, Alert
} from '@vkontakte/vkui';


import {
    Icon20AddCircleFillGreen, Icon20CopyOutline, Icon20DeleteOutline,
    Icon24Refresh, Icon24Search,
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import BaseList from "../components/BaseList";
import withOffline from "../components/withOffline";

import {AdaptivityContext, MODAL_SELECT_LIST, setQuizStep} from "../assets/constants";

import KBInput from "../assets/KBInput";

import StandsSelectList from "../references/stands/standsSelectList";
import * as constants from "../assets/constants";
import StandsManagers from "../api/references/managers/standsManagers";
import StandCollectionsSelectList from "../references/standcollections/standcollectionsSelectList";
import HelpButton from "../assets/HelpButton";
import SalePointMonitoringDocsApi from "../api/SalePointMonitoringDocs";
import SalePointMonitoringDocsSync from "../utils/localDB/salePointMonitoringDocs";


class SalePointMonitoringStep3 extends BaseList {


    constructor(props) {
        super();

        const {current_document} = props
        const ids = []
        if (current_document && current_document.items) {
            const {items} = current_document
            items.forEach(el => {
                // Проверяем что элемент не null и имеет id
                if (el && el.id) {
                    ids.push(el.id)
                }
            })
        }
        this.state = {
            current_item: {},
            ids,
            current_index: -1,
            showStandsList: true,
            searchingForItem: false,
            searchPage: 1,
            initialSearchPage: 1,
            itemRefs: {},
            ...this.state
        }

        // Инициализируем таймер для автосохранения
        this.saveTimeout = null

        // Флаг автоматического скролла (instance переменная для синхронности)
        this.isAutoScrolling = false
    }

    componentWillUnmount() {
        super.componentWillUnmount()
        // Очищаем таймер при размонтировании
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout)
        }
    }

    // Метод для автосохранения документа в онлайн режиме
    autoSaveDocument = (document) => {
        // Очищаем предыдущий таймер
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout)
        }


        this.saveTimeout = setTimeout(async () => {

            //    if (!this.props.isOffline && document && document.doc_data && document.doc_data.id > 0) {
            if (document && document.doc_data) {
                const api = new SalePointMonitoringDocsSync();

                const old_guid = document.doc_data.guid

                const guid = await api.add(document)
                console.log(`Document ${guid} auto-saved successfully`)
                if(old_guid != guid){
                    document.doc_data.guid = guid
                    window.postMessage({type:'setCurrentSalePointMonitoring', value: document})
                }
            }
        }, 2000) // Задержка 1 секунда перед сохранением
    }

    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);


        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch ?? ''
        }


        StandsManagers.getList(
            {
                show_deleted: false,
                isOffline: this.props.isOffline,
                search: mainSearch,
                page,

                epp: AdaptivityContext.isMobile ? 10 : 20,
                ids: this.state.ids.join(',')
            }
        ).then(response => {

            this.setState({loading: false})
            // Проверяем наличие current_document и items
            const items = this.props.current_document && this.props.current_document.items
                ? this.props.current_document.items
                : []

            response.data.results.map(el => {
                const value = items.find(
                    v => v && v.id == el.id
                )
                if (value) {
                    el.collections = value.collections
                    el.qnt = value.qnt
                }
            })
            let old = this.state.items;

            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            if (this.state.current_item_id) {
                // Ищем элемент в текущей загруженной странице (чанке)
                const chunkIndex = response.data.results.findIndex(el => this.state.current_item_id == el.id)
                
                if (chunkIndex !== -1) {
                    // Элемент найден в текущей загрузке!
                    
                    // Находим его глобальный индекс в полном списке (old уже содержит добавленные элементы)
                    const globalIndex = old.findIndex(el => el.id == this.state.current_item_id)
                    const current_item = old[globalIndex]
                    
                    // Обновляем стейт: устанавливаем текущую страницу и найденный элемент
                    // Важно: не перезагружаем список, так как он уже содержит нужные данные
                    this.setState({
                        current_item, 
                        current_index: globalIndex, 
                        showStandsList: false, 
                        current_item_id: null,
                        searchingForItem: false,
                        searchPage: 1,
                        initialSearchPage: 1,
                        page: page // Обновляем текущую страницу в стейте до той, где нашли элемент
                    })
                    
                    // Скроллим к найденному элементу и затем открываем модальное окно
                    setTimeout(() => {
                        this.scrollToItem(current_item.id, globalIndex)

                        // После завершения скролла и подсветки открываем модальное окно
                        setTimeout(() => {
                            if (!current_item.is_competitor) {
                                this.setActiveModal(MODAL_SELECT_LIST)
                            } else {
                                window.postMessage({type: 'openKBInputById', uid: current_item.id})
                            }
                        }, 1000) // Ждем завершения скролла (800ms) + буфер для подсветки
                    }, 200)
                } else if (this.state.searchingForItem) {
                    // Элемент не найден на текущей странице, продолжаем поиск на следующей
                    const nextPage = page + 1
                    if (nextPage <= response.data.iTotalPages) {
                        // Загружаем следующую страницу с добавлением к списку (append=true)
                        // Также обновляем page в стейте, чтобы список "знал", что мы загрузили больше страниц
                        this.setState({
                            searchPage: nextPage,
                            page: nextPage
                        })
                        setTimeout(() => {
                            this.getItems(mainSearch, true, nextPage)
                        }, 100)
                    } else {
                        // Все страницы проверены, элемент не найден
                        this.setState({
                            searchingForItem: false,
                            searchPage: 1,
                            initialSearchPage: 1,
                            current_item_id: null
                        })
                    }
                }
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    checkScroll = () => {
        if (AdaptivityContext.isMobile && !this.isAutoScrolling && !this.state.activeModal) {
            let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

            if (!headerMobStorage || headerMobStorage.length === 0) return

            headerMobStorage = headerMobStorage[0]
            const scrolled = window.scrollY

            if (scrolled > 100 && scrolled > this.scrollPrev) {
              //  headerMobStorage.classList.add('out')
            } else {
                //headerMobStorage.classList.remove('out')
            }
            this.scrollPrev = scrolled
        }

        if (!this.ref.current) return
        if (this.state.cnt_items * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems('', true, page)


        }
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: 'flex-start'}}>
                    <Button size="l" mode='outline' before={<Icon20AddCircleFillGreen/>}
                            onClick={() => {
                                this.setState({showStandsList: true});
                                this.setActiveModal(MODAL_SELECT_LIST)
                            }
                            }>Отметьте стенды</Button>
                </SplitCol>

                <SplitCol>
                    <Div style={{display: 'flex', flexDirection: 'column'}}>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>
                        {this.props.isOffline && <Chip style={{float: 'right'}} removable={false} className="all-docs"
                                                       id="is_offline">Offline режим<HelpButton
                            text={"Нет связи с интернет. Работаем в автономном режиме"}/></Chip>}

                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }

    receiveMessage = (event) => {

        if (event.data.type === 'addBrandToMonitoring') {
            const {value} = event.data
            if (value && value.id) {
                this.setActiveModal(null)
                value.uid = value.id
                this.addIds(value)
            }
        }
        if (event.data.type === 'selectListObject') {
            const {current_item} = this.state
            if (event.data.item) {
                const {item} = event.data
                if (!current_item.collections) {
                    current_item.collections = {}
                }

                if (item.checked) {
                    current_item.collections[item.id] = item
                } else if (current_item.collections[item.id]) {
                    delete current_item.collections[item.id]
                }

                const {items, current_index} = this.state
                const {current_document} = this.props

                // Инициализируем items если его нет
                if (!current_document.items) {
                    current_document.items = []
                }

                const values = current_document.items

                items[current_index] = current_item

                values[current_item.id] = current_item

                this.setState({items})

                current_document.items = values

                window.postMessage({type: 'setCurrentSalePointMonitoring', value: current_document})

                // Автосохранение в онлайн режиме
                this.autoSaveDocument(current_document)
            }
        }
    }

    interval = null
    setCompetitorValue = (current_index, val) => {
        if (this.interval) {
            clearInterval(this.interval)
        }

        this.interval = setInterval(() => {
            clearInterval(this.interval)
            const {items} = this.state
            const {current_document} = this.props

            // Инициализируем items если его нет
            if (!current_document.items) {
                current_document.items = []
            }

            const current_item = items[current_index]
            const values = current_document.items.filter(v => v && v.id != current_item.id)
            if (val > 0) {
                current_item.qnt = val

                items[current_index] = current_item

                values[current_item.id] = current_item
            }

            this.setState({items})

            current_document.items = values

            window.postMessage({type: 'setCurrentSalePointMonitoring', value: current_document})

            // Автосохранение в онлайн режиме
            this.autoSaveDocument(current_document)
        }, 770)
    }


    deleteItem = (item, index) => {


        console.log(item, this.state.ids)
        const alert = <Alert
            onClose={() => this.setState({currentPopout: null})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Да',
                    action: () => {

                        const ids = this.state.ids.filter(el => el != item.id)
                        const {items} = this.state
                        items.splice(index, 1)

                        // Обновляем current_document
                        const {current_document} = this.props
                        if (current_document.items && Array.isArray(current_document.items)) {
                            current_document.items = current_document.items.filter(el => el && el.id != item.id)
                        } else {
                            current_document.items = []
                        }

                        this.setState({items, ids, currentPopout: null})

                        window.postMessage({type: 'setCurrentSalePointMonitoring', value: current_document})

                        // Автосохранение в онлайн режиме
                        this.autoSaveDocument(current_document)
                    },

                },
                {
                    title: 'Нет',
                    action: () => {
                        this.setState({currentPopout: null})
                    },
                },
            ]}

            header="Удаление позиции"
            text={`Удалить стенд ${item.title}?`}
        />

        this.setState({currentPopout: alert})
    }

    types = constants.getEquipmentTypes()
    renderRow = (item, index) => {

        const groups = []
        const groupIndex = {}
        let num_collections = 0
        if (item.collections) {
            num_collections = Object.keys(item.collections).length
            Object.keys(item.collections).forEach(id => {
                const c = item.collections[id]
                const key = c.kit_id ? `kit-${c.kit_id}` : 'none'
                if (groupIndex[key] === undefined) {
                    groupIndex[key] = groups.length
                    groups.push({
                        key,
                        title: c.kit_title || '',
                        items: [],
                    })
                }
                groups[groupIndex[key]].items.push({id, title: c.title})
            })
            groups.sort((a, b) => (a.key === 'none') - (b.key === 'none'))
        } else if (item.qnt) {
            num_collections = item.qnt
        }

        return <RichCell 
                         data-item-id={item.id}
                         onClick={() => {

            this.setState({current_item: item, current_index: index, showStandsList: false});

            if (item.is_competitor) return
            this.setActiveModal(MODAL_SELECT_LIST)
        }}
                         afterCaption={<div style={{
                             display: "flex",
                             flexDirection: "column",

                         }}>
                             {!item.is_competitor ? <Button mode="outline" size="m"
                                 >{num_collections}</Button>
                                 :

                                 <KBInput value={item.qnt ?? ''}
                                          style={{
                                              width: '62px',
                                              padding: '7px',
                                              justifyContent: 'center',
                                              fontSize: '17px'
                                          }}
                                          uid={item.id}
                                          onChange={(val) => this.setCompetitorValue(index, val)}/>
                             }
                             <Button mode="outline" size="m"
                                     onClick={e => {
                                         e.stopPropagation()
                                         e.preventDefault()
                                         this.deleteItem(item, index)
                                     }}><Icon20DeleteOutline/></Button>
                         </div>
                         }

                         caption={<div>
                             {groups.map(group => <div key={group.key} style={{marginBottom: '6px'}}>
                                 {group.title ? <div style={{
                                     fontSize: '12px',
                                     fontWeight: 600,
                                     margin: '2px 0 2px 5px',
                                     color: '#2f6f62',
                                 }}>{group.title}</div> : null}
                                 <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                     {group.items.map(collection =>
                                         <span key={collection.id} style={{
                                             fontSize: '12px',
                                             marginLeft: '5px',
                                             marginBottom: '2px',
                                             padding: '5px 9px 5px 9px',
                                             color: '#404040',
                                             backgroundColor: "#d2e7e2",
                                             borderRadius: '15px'
                                         }}>{collection.title}</span>)}
                                 </div>
                             </div>)}
                         </div>}
                         style={{
                             backgroundColor: item.is_competitor ? 'rgba(88,117,183,0.4)' : 'inherit',
                             border: item.id && item.id == this.state.current_item.id ? '2px solid orange' : 'inherit'
                         }}
        >
            {item.title} {item.type_id > 0 ? <b>{this.types[item.type_id]}</b> : <b>Тип не указан</b>}
        </RichCell>
    }

    scrollToItem = (itemId, index) => {
        // Пытаемся найти элемент в DOM по data-атрибуту
        const element = document.querySelector(`[data-item-id="${itemId}"]`)
        if (element) {
            // Устанавливаем флаг автоматического скролла (синхронно!)
            this.isAutoScrolling = true

            element.scrollIntoView({ behavior: 'smooth', block: 'center' })

            // Сбрасываем флаг через время анимации скролла (примерно 600ms для smooth + буфер)
            setTimeout(() => {
                this.isAutoScrolling = false
            }, 800)

            // Подсвечиваем элемент
            element.style.transition = 'background-color 0.3s'
            element.style.backgroundColor = 'rgba(255, 165, 0, 0.3)'
            setTimeout(() => {
                element.style.backgroundColor = ''
            }, 2000)
        }
    }

    addIds = (item) => {
        const {ids} = this.state
        ids.push(item.uid)

        item.collections = {}

        // Обновляем current_document
        const {current_document} = this.props
        if (!current_document.items) {
            current_document.items = []
        }
        current_document.items[item.id] = item

        // Устанавливаем флаг поиска и начинаем поиск с первой страницы
        this.setState({
            current_item_id: item.uid, 
            ids, 
            activeModal: null,
            searchingForItem: true,
            searchPage: 1,
            initialSearchPage: 1,
            page: 1
        })

        window.postMessage({type: 'setCurrentSalePointMonitoring', value: current_document})

        // Автосохранение в онлайн режиме
        this.autoSaveDocument(current_document)

        setTimeout(() => {
            this.getItems('', false, 1)
        }, 300)
    }

    render() {


        const modalBrands = <StandsSelectList
            activeModal={this.state.activeModal}
            modalBack={() => this.modalBack()}
            setActiveModal={modal_id => {

                this.setActiveModal(modal_id)
            }}
            current_item={this.state.current_item}
            isOffline={this.props.isOffline}
            app="stands"
            act="getList"
            modal_title={`Добавить стенд`}
            selectObject={this.addIds}
            params={{hideAnalogs: 1}}
            header_info_message={'Введите в поиске нужный стенд. Если не нашли - нажмите добавить новый'}
            no_multiselect

        />
        const modalCollections = <StandCollectionsSelectList
            activeModal={this.state.activeModal}
            modalBack={this.modalBack}
            current_item={this.state.current_item}
            isOffline={this.props.isOffline}
            params={{stand_id: this.state.current_item.id}}
            modal_title={`Коллекции стенда ${this.state.current_item.title}`}

        />
        return <div>
            <SplitLayout popout={this.state.currentPopout}
                         modal={
                             this.state.showStandsList ? modalBrands : modalCollections
                         }
            >
                <SplitCol>
                    <PanelHeader fixed={true}
                                 before={AdaptivityContext.isMobile && !this.props.parent_product_id ?
                                     <PanelHeaderButton style={{display: 'inline'}}
                                                        onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : ''}
                                 after={!this.state.showSearch || !AdaptivityContext.isMobile ?
                                     <Div style={{display: "flex"}}>

                                         <Button size="s" mode="tertiary" style={{maxWidth: "42px"}}
                                                 onClick={() => this.doRefresh()}><Icon24Refresh/></Button>
                                     </Div> : ''}
                    >
                        <Div>
                            <form onSubmit={e => {
                                e.preventDefault();
                                e.stopPropagation()
                            }}>
                                {this.state.showSearch || !AdaptivityContext.isMobile ?
                                    <form onSubmit={e => {
                                        e.preventDefault();
                                        e.stopPropagation()
                                    }}>
                                        <Search autoFocus

                                                theme="header"
                                                placeholder="Поиск"
                                                value={this.state.mainSearch}
                                                onChange={this.onSearchChange}
                                                onClose={this.toggleSearch}

                                                style={{flexGrow: '1', maxWidth: '350px'}}
                                        /></form> : <span
                                        style={{
                                            fontSize: '19px',
                                            letterSpacing: '-0.07rem'
                                        }}>Мониторинг точки. Шаг 4</span>

                                }
                            </form>

                        </Div>
                    </PanelHeader>
                    {this.renderToolbar()}
                    {!this.state.loading && Array.isArray(this.state.items)
                        && this.state.items.length === 0 && <Cell key={'notFound' + 0}>Ничего не найдено</Cell>}
                    {this.state.items.map((item, index) => {


                        return [<SplitLayout>

                            <SplitCol width={110}>
                                <List>
                                    {this.renderRow(item, index)}

                                </List>
                            </SplitCol>
                        </SplitLayout>,

                            <hr/>]
                    })}
                    {AdaptivityContext.isMobile || true ?
                        <div ref={this.ref} key="loader"
                             style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}
                    {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                        <div style={{background: "whitesmoke", position: "fixed", bottom: "102px", zIndex: '99'}}>
                            <Pagination currentPage={this.state.page}
                                        totalPages={this.state.totalPages}
                                        onChange={this.setPage}/>
                        </div> : ''}
                </SplitCol>
            </SplitLayout>
            <SplitLayout>
                <SplitCol>
                    <Div className="action-board">
                        <ButtonGroup mode="horizontal" stretched>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={() => setQuizStep(3, 'SalePointMonitoring')}>Назад</Button>
                            <Button size={AdaptivityContext.isMobile ? 'm' : 'l'} mode='outline' before={<Icon20AddCircleFillGreen/>}
                                    onClick={() => {
                                        this.setState({showStandsList: true});
                                        this.setActiveModal(MODAL_SELECT_LIST)
                                    }
                                    }>Отметьте стенды</Button>
                            <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                    onClick={() => this.nextStep()}>Далее</Button>
                        </ButtonGroup>
                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>

    }

    nextStep = () => {

        let error = 0

        const {current_document} = this.props

        console.log(current_document)
        if (!current_document || !Array.isArray(current_document.items) || current_document.items.length === 0) {
            error++
            window.postMessage({type: 'error', text: 'Необходимо заполнить хотя бы одну позицию'})
        }


        if (error > 0) return

        setQuizStep(5, 'SalePointMonitoring')

    }

}

export default withOffline(SalePointMonitoringStep3)